export enum WORKER_EVENT_BUS {
  SYNC_BUILDER_STATUS = 'SYNC_BUILDER_STATUS',
  BUILDER_STATUS = 'BUILDER_STATUS',
  SEND_SYNC_WORKER_MESSAGE = 'SEND_SYNC_WORKER_MESSAGE'
}